/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ExamDetailsAliases {
  BREADCRUMB_DETAILS_EXAM_DETAILS = 'breadcrumb-details-exam-details',
  BUTTON_EMAIL = 'button-email',
  CARD_EXAMS_ESTABLISHMENT_INFORMATION_RIGHT_CARD_EXAM_DETAILS = 'card-exams-establishment-information-right-card-exam-details',
  CARD_EXAMS_INFORMATION_EXAM_LEFT_CARD_EXAM_DETAILS = 'card-exams-information-exam-left-card-exam-details',
  CARD_EXAMS_LIST_ITEM = 'card-exams-list-item',
  CARD_EXAMS_TITLE_EXAMS_TITLE_EXAM_DETAILS = 'card-exams-title-exams-title-exam-details',
  CONTEXTUAL_BAR_EXAM_DETAILS_EXAM_DETAILS = 'contextual-bar-exam-details-exam-details',
  DECK_EXAMS = 'deck-exams',
  DOWNLOAD_EXAM_BTN = 'download-exam-btn',
  FETCH_EXAM_DETAILS = 'fetch-exam-details',
  FETCH_EXAMS = 'fetch-exams',
  FRAGMENT_0 = 'fragment-0',
  FRAGMENT_REFERENCE_ANALYTICS = 'fragment-reference-analytics',
  LAYOUT_CONTENT = 'layout-content',
  LAYOUT_EXAM_DETAILS = 'layout-exam-details',
  LAYOUT_EXAM_LIST_EXAM_DETAILS = 'layout-exam-list-exam-details',
  LAYOUT_EXAMS_CARD_EXAM_DETAILS = 'layout-exams-card-exam-details',
  LAYOUT_EXAMS_DETAILS_EXAM_DETAILS = 'layout-exams-details-exam-details',
  LAYOUT_REPORT = 'layout-report',
  LAYOUT_TAG = 'layout-tag',
  LOADER_ESTABLISHMENT = 'loader-establishment',
  LOADER_EXAM_TITLE_EXAM_DETAILS = 'loader-exam-title-exam-details',
  LOADER_LEFT_CARD_EXAM_DETAILS = 'loader-left-card-exam-details',
  LOADER_REPORT = 'loader-report',
  PAC_BTN = 'pac-btn',
  PANEL_EXAM_CARD = 'panel-exam-card',
  PANEL_EXAM_DETAILS = 'panel-exam-details',
  PANEL_EXAM_LEFT_CARD = 'panel-exam-left-card',
  PANEL_EXAM_LIST = 'panel-exam-list',
  PANEL_EXAM_RIGHT_CARD = 'panel-exam-right-card',
  PANEL_EXAM_TITLE = 'panel-exam-title',
  PANEL_EXAM_TITLE_LOADER_EXAM_DETAILS = 'panel-exam-title-loader-exam-details',
  PANEL_LEFT_CARD_LOADER_EXAM_DETAILS = 'panel-left-card-loader-exam-details',
  PANEL_LOADER_ESTABLISHMENT = 'panel-loader-establishment',
  PANEL_LOADER_REPORT = 'panel-loader-report',
  PANEL_MESSAGE = 'panel-message',
  PANEL_REPORT = 'panel-report',
  PANEL_TAG_REVIEW = 'panel-tag-review',
  PANEL_TITLE_LIST = 'panel-title-list',
  PDF_VIEWER_EXAM_DETAILS = 'pdf-viewer-exam-details',
  ROUTE_0 = 'route-0',
  TAG_REVIEW = 'tag-review',
  TEXT_MESSAGE_EXAM_DETAILS = 'text-message-exam-details',
  TEXT_TITLE_LIST = 'text-title-list',
}
export { ExamDetailsAliases };
